const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 18 18",
    width: "18px",
    height: "18px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface114753864"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 9 2.398438 C 6.488281 2.398438 3.226562 3.027344 3.226562 3.027344 L 3.21875 3.039062 C 2.078125 3.222656 1.199219 4.203125 1.199219 5.398438 L 1.199219 12.601562 C 1.203125 13.78125 2.0625 14.785156 3.226562 14.96875 C 3.226562 14.96875 6.488281 15.601562 9 15.601562 C 11.511719 15.601562 14.769531 14.96875 14.769531 14.96875 L 14.773438 14.96875 C 15.9375 14.785156 16.796875 13.78125 16.800781 12.601562 L 16.800781 5.398438 C 16.796875 4.21875 15.9375 3.214844 14.773438 3.03125 L 14.769531 3.03125 C 14.769531 3.03125 11.511719 2.398438 9 2.398438 Z M 7.199219 6.238281 L 12 9 L 7.199219 11.761719 Z M 7.199219 6.238281 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.7020b01efa5ca2251ad4ab68cf6b70c0.svg";
export { ForwardRef as ReactComponent };